// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper__3tE9E","content":"content__OxsNO","heading":"heading__2IVL6","text":"text__3vYMK"};